angular.module('rightPaneModule')
  .directive('supportLink', function() {
    return {
      scope: {
        supportUrl: '@'
      },
      restrict: 'E',
      templateUrl: '/resources/right-pane/components/support-link/support-link.directive.html'
    };
  });
